// @flow
// $FlowFixMe
import React, {useMemo} from 'react';
import {FormattedMessage} from 'react-intl';
import {
    addDaysToDate as addDays,
    subtractDaysFromDate as subDays,
    isBefore
} from '@homeaway/date-utils';
import classNames from 'classnames';
import type {
    FlexibleDatesOptionProps,
    FlexibleDatesOptionExtraProps
} from './FlexibleDates';

import FlexibleDatesOptionIcon from './FlexibleDatesOptionIcon';

import './FlexibleDatesOption.less';

function calculateRange(
    type: 'add' | 'sub',
    days: number,
    startDate: Date,
    endDate: Date
): [Date, Date] {
    const method = type === 'add' ? addDays : subDays;
    return [method(startDate, days), method(endDate, days)];
}

type Props = {
    type: 'add' | 'sub'
} & FlexibleDatesOptionProps &
    FlexibleDatesOptionExtraProps;

export default function FlexibleDatesOption({
    type,
    id,
    label,
    startDate,
    endDate,
    days,
    onDateChange,
    loading,
    locale
}: Props) {
    const [newStartDate, newEndDate] = useMemo(
        () => calculateRange(type, days, startDate, endDate),
        [type, days, startDate, endDate]
    );

    function changeDates() {
        onDateChange({
            startDate: newStartDate,
            endDate: newEndDate,
            eventlabel: label.toLowerCase()
        });
    }

    let sameDayUnavailable = false;

    if (type === 'sub') {
        if (isBefore(newStartDate, subDays(new Date(Date.now()), 1))) {
            sameDayUnavailable = true;
        }
    }

    const {format} = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short'
    });

    const flexibleDatesOptionMarkup = (unavailable) => (
        <button
            type="button"
            className={classNames('FlexibleDatesOption', {
                'FlexibleDatesOption--right': type === 'add',
                'FlexibleDatesOption--unavailable': unavailable
            })}
            onClick={changeDates}
            disabled={!!loading || unavailable}
        >
            <FlexibleDatesOptionIcon type={type} days={days} />
            <span className="FlexibleDatesOption__Text">
                <span className="FlexibleDatesOption__Label">
                    <FormattedMessage
                        id={`flexibleDates${id}`}
                        defaultMessage={label}
                    />
                </span>
                <span className="FlexibleDatesOption__Dates">
                    {unavailable ? (
                        <FormattedMessage
                            id="flexibleDatesUnavailable"
                            defaultMessage="Unavailable"
                        />
                    ) : (
                        `${format(newStartDate)} – ${format(newEndDate)}`
                    )}
                </span>
            </span>
        </button>
    );

    return flexibleDatesOptionMarkup(sameDayUnavailable);
}
